import { Skeleton } from "@mui/material";
import React from "react";

interface BlogCardSkeletonProps {
  count?: number;
}

const BlogCardSkeleton: React.FC<BlogCardSkeletonProps> = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-md overflow-hidden h-full flex flex-col"
        >
          {/* Image Skeleton */}
          <div className="relative w-full h-64 overflow-hidden">
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              className="bg-gray-200"
            />
            {/* Category Tag Skeleton */}
            <div className="absolute bottom-4 left-4">
              <Skeleton
                variant="rectangular"
                width={80}
                height={24}
                className="rounded-md bg-gray-300"
              />
            </div>
          </div>

          {/* Content Skeleton */}
          <div className="p-6 flex-1 flex flex-col">
            {/* Title Skeleton */}
            <Skeleton
              variant="text"
              width="90%"
              height={28}
              className="mb-3"
            />
            <Skeleton
              variant="text"
              width="70%"
              height={28}
              className="mb-3"
            />
            {/* Date Skeleton */}
            <div className="flex items-center gap-2 mt-auto">
              <Skeleton variant="circular" width={16} height={16} />
              <Skeleton variant="text" width={120} height={20} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlogCardSkeleton;

